import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DSButton, DSIcon } from '../design-system/primitives';
import './RSVPConfirmation.css';

function RSVPConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { event, accountCreated } = location.state || {};

  if (!event) {
    return (
      <div className="confirmation-page">
        <div className="confirmation-container">
          <h1>RSVP Submitted</h1>
          <p>Thank you for your RSVP!</p>
          <DSButton appearance="solid" tone="primary" onClick={() => navigate('/')}>
            Go to Home
          </DSButton>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };

  // Create calendar link (Google Calendar format)
  const eventDate = new Date(event.event_date);
  const calendarTitle = encodeURIComponent(event.title);
  const calendarLocation = encodeURIComponent(event.location || '');
  const calendarDate = eventDate.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${calendarTitle}&dates=${calendarDate}/${calendarDate}&location=${calendarLocation}`;

  return (
    <div className="confirmation-page">
      <div className="confirmation-container">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="38" fill="var(--ds-color-statusSuccessText)" />
            <path d="M25 40 L35 50 L55 30" stroke="white" strokeWidth="5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1>You're All Set!</h1>
        <p className="subtitle">Can't wait to see you at Capital Pinball!</p>

        <div className="event-summary">
          <h2>{event.title}</h2>
          <p className="event-date"><DSIcon name="calendar" /> {formatDate(event.event_date)}</p>
          {event.location && <p className="event-location"><DSIcon name="pin" /> {event.location}</p>}
        </div>

        <div className="action-buttons">
          <a 
            href={calendarUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            <DSIcon name="calendar" /> Add to Calendar
          </a>
        </div>

        {accountCreated && (
          <div className="account-notice">
            <h3><DSIcon name="sparkles" /> Your Account Has Been Created!</h3>
            <p>
              We've created an account for you to make check-in easier at the event.
              Check your email for your login credentials.
            </p>
            <p>
              <strong>What you can do with your account:</strong>
            </p>
            <ul>
              <li>View your QR code for fast check-in</li>
              <li>See all your upcoming events</li>
              <li>Manage your RSVPs</li>
            </ul>
            <DSButton
              appearance="outline"
              tone="secondary"
              onClick={() => navigate('/login')}
            >
              Sign In to Your Account
            </DSButton>
          </div>
        )}

        {!accountCreated && (
          <div className="account-notice">
            <p>
              <strong>Pro tip:</strong> Log in to your account to view your QR code for fast check-in at the event!
            </p>
            <DSButton
              appearance="outline"
              tone="secondary"
              onClick={() => navigate('/login')}
            >
              Sign In
            </DSButton>
          </div>
        )}

        <div className="contact-info">
          <p>If you have any questions, feel free to contact us.</p>
        </div>
      </div>
    </div>
  );
}

export default RSVPConfirmation;
